import { StyleRules } from '@material-ui/core/styles';
import { FormHelperTextClassKey } from '@material-ui/core/FormHelperText';

import { core as theme } from '../styles/core';

export const MuiFormHelperText: Partial<StyleRules<FormHelperTextClassKey>> = {
  root: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.grey[600],
    "&.Mui-error": {
      color: theme.palette.error.dark,
    } 
  },
};
